import React from 'react';
import { Sidebar } from '@common/components/sidebar';

export const OrganizationSidebar = ({
  selectedItem,
  showReports,
  showAdminItem,
  showOrganizationBillingItem,
  showTimesheetsItem,
  showStaffingItem,
  showCandidatesItem,
  showOnboardingItem,
  showShiftItem,
  showTeamItem,
}: {
  selectedItem?: string;
  showStaffingItem?: boolean;
  showReports?: boolean;
  showAdminItem?: boolean;
  showOrganizationBillingItem?: boolean;
  showTimesheetsItem?: boolean;
  showCandidatesItem?: boolean;
  showOnboardingItem?: boolean;
  showShiftItem?: boolean;
  showTeamItem?: boolean;
}) => (
  <Sidebar logoTo="/works" selectedItem={selectedItem}>
    {showStaffingItem && (
      <Sidebar.Item
        key="staffing"
        to="/works/staffing-requests"
        icon={{ kind: 'light', icon: 'suitcase' }}
      >
        Staffing
      </Sidebar.Item>
    )}

    {showCandidatesItem && (
      <Sidebar.Item
        key="applications"
        to="/works/applications"
        icon={{ kind: 'light', icon: 'pollPeople' }}
      >
        Applications
      </Sidebar.Item>
    )}

    {showTeamItem && (
      <Sidebar.Item
        key="team"
        to="/works/team"
        icon={{ kind: 'light', icon: 'users' }}
      >
        Team
      </Sidebar.Item>
    )}
    {showShiftItem && (
      <Sidebar.Item
        key="shift"
        to="/works/shifts"
        icon={{ kind: 'light', icon: 'calendar' }}
      >
        Shifts
      </Sidebar.Item>
    )}
    {showOnboardingItem && (
      <Sidebar.Item
        key="compliance"
        to="/works/compliance"
        icon={{ kind: 'light', icon: 'clipboardListCheck' }}
      >
        Compliance
      </Sidebar.Item>
    )}
    {showTimesheetsItem ? (
      <Sidebar.Item
        key="timecards"
        to="/works/timecards"
        icon={{ kind: 'light', icon: 'clock' }}
      >
        Timecards
      </Sidebar.Item>
    ) : null}
    {showOrganizationBillingItem ? (
      <Sidebar.Item
        key="billing"
        to="/works/billing"
        icon={{ kind: 'light', icon: 'fileInvoice' }}
      >
        Billing
      </Sidebar.Item>
    ) : null}
    {showReports && (
      <Sidebar.Item
        key="reports"
        to="/works/reports"
        icon={{ kind: 'light', icon: 'chartBar' }}
      >
        Reports
      </Sidebar.Item>
    )}
    {showAdminItem && (
      <Sidebar.Item
        key="admin"
        to="/works/admin"
        icon={{ kind: 'light', icon: 'userCog' }}
      >
        Admin
      </Sidebar.Item>
    )}
  </Sidebar>
);
